import React, { useState } from 'react';
import { Phone, MessageCircle, Send, Menu, X, ChevronDown } from 'lucide-react';
const LOGO = 'https://cdn.magicpatterns.com/uploads/fhwuVqQzZmxd9UpG8B8pLc/tulsa-water-favicon.png';
const NAV = [{
  label: 'Products',
  href: '#products'
}, {
  label: 'How It Works',
  href: '#how'
}, {
  label: 'Service Areas',
  href: '#areas'
}, {
  label: 'Gallery',
  href: '#gallery'
}, {
  label: 'Reviews',
  href: '#reviews'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/95 backdrop-blur" data-id="element-53" data-mp="1oldodj5l6xa0">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6" data-id="element-54" data-mp="1tmjkzs2db4ot">
        <a href="#top" className="flex shrink-0 items-center gap-2.5" aria-label="Tulsa Water Pros home" data-id="element-55" data-mp="1yjjpvznhe1ec">
          <img src={LOGO} alt="" className="h-10 w-10 object-contain sm:h-11 sm:w-11" data-id="element-56" data-mp="3ve6bztm9ezla" />
          <span className="font-heading text-lg font-extrabold tracking-tight text-navy-900 sm:text-xl" data-id="element-57" data-mp="47mrtnuj9xab">
            Tulsa Water <span className="text-brand-blue" data-id="element-58" data-mp="2gogo6m7ej9xu">Pros</span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary" data-id="element-59" data-mp="2bv49p4wfsjit">
          {NAV.map(item => <a key={item.label} href={item.href} className="text-sm font-semibold text-navy-900 transition-colors hover:text-brand-blue" data-id="element-60" data-mp="26xlyt8yuzu86">
              {item.label}
            </a>)}
        </nav>

        <div className="hidden items-center gap-3 lg:flex" data-id="element-61" data-mp="2um55xl66a0yo">
          <a href="tel:+19185550123" className="inline-flex items-center gap-2 rounded-full border border-brand-blue px-4 py-2.5 text-sm font-bold text-brand-blue transition-colors hover:bg-brand-blue hover:text-white" data-id="element-62" data-mp="2uku5nvbxrbcb">
            <Phone className="h-4 w-4" data-id="element-63" data-mp="1f6xyfz50esvk" />
            (918) 555-0123
          </a>
          <a href="sms:+19185550123" className="inline-flex items-center gap-2 rounded-full bg-brand-blue px-4 py-2.5 text-sm font-bold text-white transition-colors hover:bg-navy-700" data-id="element-64" data-mp="1a6a9dj0ccm3z">
            <MessageCircle className="h-4 w-4" data-id="element-65" data-mp="1glqztd61h16z" />
            Text Us
          </a>
          <a href="#quote" className="inline-flex items-center gap-2 rounded-full bg-brand-cyan px-4 py-2.5 text-sm font-bold text-white shadow-lg shadow-brand-cyan/25 transition-colors hover:bg-brand-blue" data-id="element-66" data-mp="12o2clyoi1hyr">
            <Send className="h-4 w-4" data-id="element-67" data-mp="sw6bsfv13dqu" />
            Quick Quote
          </a>
        </div>

        <button className="inline-flex items-center justify-center rounded-lg p-2 text-navy-900 lg:hidden" onClick={() => setOpen(v => !v)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-68" data-mp="xpir1zdti86x">
          {open ? <X className="h-6 w-6" data-id="element-69" data-mp="9zofdl58ipo9" /> : <Menu className="h-6 w-6" data-id="element-70" data-mp="9z55mrpqn7lb" />}
        </button>
      </div>

      {open && <div className="border-t border-slate-200 bg-white lg:hidden" data-id="element-71" data-mp="ewew8aov5paq">
          <nav className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-4" aria-label="Mobile" data-id="element-72" data-mp="3rgsq96xx9uhq">
            {NAV.map(item => <a key={item.label} href={item.href} onClick={() => setOpen(false)} className="flex items-center justify-between rounded-lg px-3 py-3 text-base font-semibold text-navy-900 hover:bg-slate-50" data-id="element-73" data-mp="3mjsgakxyc7lc">
                {item.label}
                <ChevronDown className="h-4 w-4 -rotate-90 text-slate-400" data-id="element-74" data-mp="e8xvj0mv4i80" />
              </a>)}
            <div className="mt-3 flex flex-col gap-2" data-id="element-75" data-mp="99lckqz43vap">
              <a href="tel:+19185550123" className="inline-flex items-center justify-center gap-2 rounded-full border border-brand-blue px-4 py-3 text-sm font-bold text-brand-blue" data-id="element-76" data-mp="nzk9kqexl0ol">
                <Phone className="h-4 w-4" data-id="element-77" data-mp="x1jp1eaarwpf" /> (918) 555-0123
              </a>
              <a href="#quote" onClick={() => setOpen(false)} className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-cyan px-4 py-3 text-sm font-bold text-white" data-id="element-78" data-mp="s3i6qvkp41f0">
                <Send className="h-4 w-4" data-id="element-79" data-mp="2w87649efxfo9" /> Quick Quote
              </a>
            </div>
          </nav>
        </div>}
    </header>;
}